module.exports = __webpack_public_path__ + "bj.svg?486ce25912ff76c58d4404ebdd66a704";